import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import {environment} from "../../environments/environment";
import {JobTemplateList, JobTemplate} from '../models/JobTemplate';



@Injectable({
  providedIn: 'root'
})
export class JobTemplateService {

constructor(private http: HttpClient ) { }




public getAllOrSearchJobTemplats(searchString: string, page: number, pageSize: number){

    if(searchString != null &&  searchString.trim() != ""){
        return  this.searchJobTemplats(searchString,page ,pageSize);
    }
    else{
        return  this.getJobTemplats(page ,pageSize);
    }

}

public getJobTemplats(page: number, pageSize: number): Observable<JobTemplateList> {
    return this.http.get<JobTemplateList>(environment.APIENDPOINT + '/jobTemplates?page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public searchJobTemplats(searchString: string , page: number, pageSize: number): Observable<JobTemplateList> {
    return this.http.get<JobTemplateList>(environment.APIENDPOINT + '/jobTemplates/search?searchString='+searchString+'&page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }



  public getOrSearchGobalJobTemplats(searchString: string, page: number){

    if(searchString != null &&  searchString.trim() != ""){
        return this.http.get<JobTemplateList>(environment.APIENDPOINT + '/master/jobTemplates/search?searchString='+searchString+'&page='+page+'&size=5', {
            headers: this.setHeaders(),
            responseType: 'json'
          });
    }
    else{
        return this.http.get<JobTemplateList>(environment.APIENDPOINT + '/master/jobTemplates?page='+page+'&size=10', {
            headers: this.setHeaders(),
            responseType: 'json'
          });
    }

}

public importJobTemplats(templates: JobTemplate[] , userId : number) {

    return this.http.post(environment.APIENDPOINT + "/jobTemplates/import?userId=" + userId, templates,
        {
            headers: this.setHeaders(),
            responseType: 'json'
        }
    );

}


    public addJobTemplats(template: JobTemplate) {

        return this.http.post(environment.APIENDPOINT + "/jobTemplates", template,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );

    }

    public updateJobTemplats(template: JobTemplate) {
        return this.http.post(environment.APIENDPOINT + "/jobTemplates", template,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }



  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}


